import { render } from "./tnc.vue?vue&type=template&id=ae19275a&lang=html"
import script from "./tnc.vue?vue&type=script&lang=js"
export * from "./tnc.vue?vue&type=script&lang=js"

import "./tnc.vue?vue&type=style&index=0&id=ae19275a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__